'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var t = require('react');
var PropTypes = require('prop-types');
var Ability = require('./Ability.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var t__default = /*#__PURE__*/_interopDefaultLegacy(t);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var FeatureToggle = function FeatureToggle(_ref) {
  var action = _ref.action,
      feature = _ref.feature,
      children = _ref.children;
  return /*#__PURE__*/t__default['default'].createElement(Ability.Can, {
    I: action,
    a: feature
  }, children);
};
FeatureToggle.propTypes = {
  action: PropTypes__default['default'].string,
  feature: PropTypes__default['default'].string.isRequired,
  children: PropTypes__default['default'].any
};
FeatureToggle.defaultProps = {
  action: "use"
};

exports.FeatureToggle = FeatureToggle;
exports.default = FeatureToggle;
//# sourceMappingURL=FeatureToggle.js.map
